<template>
  <section class="h-100-trim-header mt-3 mb-5 bg-light-grey">
    <div class="vertical-center text-center" id="loader-text">
      <h4>{{ loadingText }}</h4>
      <p id="video">
        <Animation ref="animation" />
      </p>
    </div>
  </section>
</template>

<script>
import Animation from "../../components/loaders/animation";
import { mapGetters } from "vuex";

export default {
  name: "pages-product-loading",
  components: {
    Animation
  },
  computed: {
    ...mapGetters({ loadingText: "ui/loadingText" })
  },
  watch: {
    loadingText() {
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
.vertical-center {
  padding-top: 25%;
  padding-right: 10%;
  padding-left: 10%;
}

#loader-text {
  padding-top: 30px;
}

#loader-text h4 {
  font-size: 1.4rem;
}

#video video {
  margin-bottom: 30px;
}
</style>
